module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Light.ee7481b4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Light.woff
// module id = 336
// module chunks = 1